<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import DataTable from '../UI/Table/DataTable.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import { isAdmin } from '../../Utils'
import { isTheme } from '../../Utils/isTheme'

export default {
  components: { DataTable, BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    entityId: { type: Number, required: true },
  },

  computed: {
    urlContract() {
      return 'entities/' + this.entityId + '/contracts'
    },
    columns() {
      return [
        {
          name: 'createdAt',
          type: 'date',
          title: this.$t('contract.list.table.labelCreatedAt'),
          style: { className: 'col-align-center' },
          formatter: 'date',
        },
        { name: 'id', displayable: false },
        { name: 'clientActor.entity.id', displayable: false },
        { name: 'supplierActor.entity.id', displayable: false },
        { name: 'refinancerNumber', displayable: false },
        {
          name: 'number',
          title: this.$t('contract.list.table.labelNumber'),
          formatter: 'context',
          options: { renderType: 'contracts', renderId: 'id' },
        },
        {
          name: 'agreementNumber',
          displayable: isTheme('lbp'),
          title: this.$t('demand.list.number'),
          style: { className: 'col-align-center' },
        },
        {
          name: 'clientActor.entity.name',
          title: this.$t('main.client'),
          formatter: 'entity',
          options: { renderId: 'clientActor.entity.id' },
        },
        {
          name: 'supplierActor.entity.name',
          displayable: isAdmin(),
          title: this.$t('main.supplier'),
          formatter: 'entity',
          options: { renderId: 'supplierActor.entity.id' },
          style: { className: 'col-align-center' },
        },
        {
          name: 'refinancer.name',
          displayable: isTheme('financia') && (user.isBusinessMan || user.isAdmin),
          title: this.$t('demand.list.refinancer'),
          style: { className: 'col-align-center' },
        },
        { name: 'platformSalesman.name', title: this.$t('contract.list.table.labelPlatformSalesman') },
        { name: 'finance.equipment.equipmentType.name', title: this.$t('contract.list.table.equipment') },
        {
          name: 'finance.amount',
          title: this.$t('contract.list.table.labelTotalAmount'),
          formatter: 'currency',
          style: { width: '60px' },
        },
        {
          name: 'status',
          title: this.$t('contract.list.table.labelStatus'),
          style: { width: '120px' },
          formatter: 'status',
          options: { renderType: 'contract' },
        },
      ]
    },
  },

  methods: {
    getContracts(callback) {
      this.getJSON(this.urlContract).then((contracts) => {
        callback({ data: contracts })
      })
    },
  },
}
</script>
<template>
  <BlockContent>
    <DataTable
      id="listeContratSociete"
      :columns="columns"
      ref="listeContratSociete"
      :fetch="getContracts"
      :order="[[0, 'desc']]"
      :zero-records="$t('contract.list.zeroRecords')"
    />
  </BlockContent>
</template>
